import React                            from 'react';
import { Observe }                      from 'rewire-core';
import SettingsModel                    from './SettingsModel';
import { Theme, makeStyles }            from '../utility/styles';
import {
  DefaultEditPanelView,
}                                       from './DefaultSettingsView';
import { IInfoPanelProps }              from '../ui/InfoPanel';
import ArchiveDeleteGroupDialog         from './ArchiveDeleteGroupDialog';

const useGroupEditPanelViewStyles = makeStyles((_theme: Theme) => ({
  infoPanelRoot: {
  },
}));

const GroupEditPanelView = ({ settings, classes, InfoPanelProps }: { settings: SettingsModel, classes?: any, InfoPanelProps?: IInfoPanelProps }) => {
  const groupEditPanelClasses = useGroupEditPanelViewStyles({classes});
  return <Observe render={() => (
    <>
    <DefaultEditPanelView InfoPanelProps={InfoPanelProps} settings={settings} classes={groupEditPanelClasses} />
    <ArchiveDeleteGroupDialog />
    </>
  )} />;
};

export default GroupEditPanelView;